import { Eye, EyeOff } from "lucide-react";
import { useMemo, useState } from "react";
import { Input } from "../ui/input";

function AuthFormField({
	label,
	type = "text",
	value,
	onChange,
	placeholder,
	helperText,
	error,
	leftIcon,
	rightIcon,
	autoComplete,
	...props
}) {
	const [showPassword, setShowPassword] = useState(false);
	const isPassword = useMemo(()=> type ==="password", [type]);
	return (
		<div className="space-y-2">
			{label && <label className="text-sm font-medium text-muted-foreground">{label}</label>}
			<div className="relative">
				{leftIcon && <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">{leftIcon}</span>}
				<Input
					type={isPassword && showPassword ? "text" : type}
					value={value}
					onChange={onChange}
					placeholder={placeholder}
					autoComplete={autoComplete}
					className={`pl-${leftIcon ? "10" : "3"} pr-${isPassword ? "10" : rightIcon ? "10" : "3"} ${error ? "border-red-500" : ""}`}
					{...props}
				/>
				{isPassword && (
					<button
						type="button"
						className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground"
						onClick={() => setShowPassword((v) => !v)}
						tabIndex={-1}
					>
						{showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
					</button>
				)}
				{rightIcon && !isPassword && (
					<span className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground">{rightIcon}</span>
				)}
			</div>
			{helperText && <p className="text-xs text-muted-foreground">{helperText}</p>}
			{error && <p className="text-xs text-red-500">{error}</p>}
		</div>
	);
}
export default AuthFormField;